import { callApi } from '../../../../../apiCaller';
import { toastError } from '../../../../../utils';
import { setIsLoading } from '../../../../../actions/general';
import { toast } from 'react-toastify';
import { DEFAULT_FN } from '../../../../../constants';

export const SET_COURSES = 'setCourses';
export const UPDATE_COURSE = 'updateCourse';

export const API_SUBSCRIBER_USER_PRODUCT = 'user/product';
export const API_SUBSCRIBER_COURSE_DETAIL = 'user/product/:courseId';

export const setCourses = (courses) => {
     return {
          type: SET_COURSES,
          payload: courses,
     };
};

export const updateCourse = (course) => {
     return {
          type: UPDATE_COURSE,
          payload: course,
     };
};

export const fetchCoursesRequest = () => (dispatch) => {
     dispatch(setIsLoading(true));
     callApi(API_SUBSCRIBER_USER_PRODUCT, 'GET')
          .then((response) => {
               if (response.status === 200) {
                    dispatch(setCourses(response.data));
               } else {
                    toastError(response);
               }
          })
          .finally(() => dispatch(setIsLoading(false)));
};

export const updateCourseRequest =
     (courseId, newCourse, nextDispatch = {}, setSubmitting = DEFAULT_FN) =>
     (dispatch, getState) => {
          const { fetchUserLesson, fetchUserLessons, handleCreateUserLesson, lessonId, fetchCoursesData, setShowPopup } = nextDispatch;
          setSubmitting(true);

          const courses = getState().subscriber.courses;

          callApi(API_SUBSCRIBER_COURSE_DETAIL.replace(':courseId', courseId), 'PUT', newCourse).then((response) => {
               if (setShowPopup) {
                    setShowPopup(false);
               }

               setSubmitting(false);

               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const courseRes = response.data;

               dispatch(updateCourse(courseRes));

               if (handleCreateUserLesson) {
                    handleCreateUserLesson(lessonId);
               }

               if (fetchUserLessons) {
                    fetchUserLessons();
               }

               if (fetchUserLesson) {
                    fetchUserLesson();
               }

               if (fetchCoursesData) {
                    const course = courses.find((course) => course.id === courseId);

                    if (course) {
                         Object.assign(course, courseRes);
                    }

                    fetchCoursesData(courses);
               }

               if (setShowPopup) {
                    toast.success('Update Successfully');
               }
          });
     };
